import { AppState } from 'store/types/Store';

export const getViewIndex = (_state: AppState, { index }: { index: number }) => index;
